import { styled } from "@mui/material/styles"

interface StyledContainerProps {
    color: string
}

export const Container = styled("div")<StyledContainerProps>(({ theme, color }) => ({
    border: `1px solid ${theme.palette[color].main}`,
    borderRadius: 12,
    display: "flex",
    gap: theme.spacing(4),
    padding: theme.spacing(3, 4),
    color: theme.palette[color].main,
}))